export enum Role {
  SUPER_ADMIN = 'LMS_SUPERADMIN',
  ADMIN = 'LMS_ADMIN',
  MODERATOR = 'LMS_MODERATOR',
  INSTRUCTOR = 'LMS_INSTRUCTOR',
  MENTOR = 'LMS_MENTOR',
  USER = 'LMS_USER'
}
